// extracted by mini-css-extract-plugin
export default {"container":"NavbarTriqui_container__emAF9","colorNav":"NavbarTriqui_colorNav__hVNl6","textBrand":"NavbarTriqui_textBrand__VDkiN","itemNavbar":"NavbarTriqui_itemNavbar__IGJ+i"};